import { FC } from "react";
import { Column, Row } from "../../../components/containers";
import { Heading } from "../../../components/typography";
import { useGeneralStore, usePopupStore, useThemeStore } from "../../../stores";
import { JustifyContent } from "../../../components/containers/types";
import { PlusIcon } from "../../../assets/icons";
import { IconAnimation } from "../../../components/animation";
import User, { UserAddPopup } from "./user";

const Users: FC = () => {
  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const onAddHandler = (): void => {
    setPopupBody(<UserAddPopup />);
  };

  const users = useGeneralStore((s) => s.users);

  return (
    <Column style={{ minWidth: 300 }} gap={10}>
      <Row
        style={{ width: "100%", height: 50 }}
        justifyContent={JustifyContent.Between}
        gap={10}
      >
        <Heading size={24} color={theme.textOnBg}>
          ادمین ها
        </Heading>
        <IconAnimation
          Icon={PlusIcon}
          onHoverColor={theme.primary}
          width={24}
          height={24}
          className="cursor-pointer"
          onClick={onAddHandler}
        />
      </Row>
      <Column
        style={{ width: "100%", overflowY: "auto", maxHeight: 460 }}
        gap={10}
      >
        {users.map((user, idx) => (
          <User {...user} key={idx} />
        ))}
      </Column>
    </Column>
  );
};

export default Users;
